var map = {
	"./Bank.svg": "./src/assets/svg/Paper/elements/Bank.svg",
	"./Barcode.svg": "./src/assets/svg/Paper/elements/Barcode.svg",
	"./Coin.svg": "./src/assets/svg/Paper/elements/Coin.svg",
	"./Copy.svg": "./src/assets/svg/Paper/elements/Copy.svg",
	"./Elipse.svg": "./src/assets/svg/Paper/elements/Elipse.svg",
	"./Information.svg": "./src/assets/svg/Paper/elements/Information.svg",
	"./Line.svg": "./src/assets/svg/Paper/elements/Line.svg",
	"./Locator.svg": "./src/assets/svg/Paper/elements/Locator.svg",
	"./Num.svg": "./src/assets/svg/Paper/elements/Num.svg",
	"./Order.svg": "./src/assets/svg/Paper/elements/Order.svg",
	"./Phone.svg": "./src/assets/svg/Paper/elements/Phone.svg",
	"./Pricetruck.svg": "./src/assets/svg/Paper/elements/Pricetruck.svg",
	"./Rectangle.svg": "./src/assets/svg/Paper/elements/Rectangle.svg",
	"./Save.svg": "./src/assets/svg/Paper/elements/Save.svg",
	"./SaveOutline.svg": "./src/assets/svg/Paper/elements/SaveOutline.svg",
	"./Social.svg": "./src/assets/svg/Paper/elements/Social.svg",
	"./Stock.svg": "./src/assets/svg/Paper/elements/Stock.svg",
	"./Text.svg": "./src/assets/svg/Paper/elements/Text.svg",
	"./Vat.svg": "./src/assets/svg/Paper/elements/Vat.svg",
	"./calculator.svg": "./src/assets/svg/Paper/elements/calculator.svg",
	"./calendar.svg": "./src/assets/svg/Paper/elements/calendar.svg",
	"./cog.svg": "./src/assets/svg/Paper/elements/cog.svg",
	"./discount.svg": "./src/assets/svg/Paper/elements/discount.svg",
	"./drag.svg": "./src/assets/svg/Paper/elements/drag.svg",
	"./edit-outline.svg": "./src/assets/svg/Paper/elements/edit-outline.svg",
	"./formula.svg": "./src/assets/svg/Paper/elements/formula.svg",
	"./internet.svg": "./src/assets/svg/Paper/elements/internet.svg",
	"./items.svg": "./src/assets/svg/Paper/elements/items.svg",
	"./left-turn-arrow.svg": "./src/assets/svg/Paper/elements/left-turn-arrow.svg",
	"./logout.svg": "./src/assets/svg/Paper/elements/logout.svg",
	"./man.svg": "./src/assets/svg/Paper/elements/man.svg",
	"./printOutline.svg": "./src/assets/svg/Paper/elements/printOutline.svg",
	"./resize-column.svg": "./src/assets/svg/Paper/elements/resize-column.svg",
	"./right-turn-arrow.svg": "./src/assets/svg/Paper/elements/right-turn-arrow.svg",
	"./share.svg": "./src/assets/svg/Paper/elements/share.svg",
	"./tags.svg": "./src/assets/svg/Paper/elements/tags.svg",
	"./trash-outline.svg": "./src/assets/svg/Paper/elements/trash-outline.svg",
	"./truck.svg": "./src/assets/svg/Paper/elements/truck.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/svg/Paper/elements sync recursive \\.svg$";